import { render, staticRenderFns } from "./BlockOfferPictureOnly.vue?vue&type=template&id=1c7062fc&"
import script from "./BlockOfferPictureOnly.vue?vue&type=script&lang=js&"
export * from "./BlockOfferPictureOnly.vue?vue&type=script&lang=js&"
import style0 from "./BlockOfferPictureOnly.vue?vue&type=style&index=0&id=1c7062fc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports